// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3wTeQ","container":"styles_container__1S7PP","title":"styles_title__2E_SD","wrapper":"styles_wrapper__3cHdI","answer":"styles_answer__1YznT"};